import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRequest, jsonBody } from '../../lib/api-client';
import type { Category, CategoryWrite } from '../../lib/api-types';

export const categoryKeys = { all: ['finance', 'categories'] as const };

export async function fetchCategories(): Promise<Category[]> {
  return (await apiRequest<{ categories: Category[] }>('/api/categories')).categories;
}

export async function createCategory(input: CategoryWrite): Promise<Category> {
  return (
    await apiRequest<{ category: Category }>('/api/categories', {
      body: jsonBody(input),
      method: 'POST',
    })
  ).category;
}

export function deleteCategory(id: string): Promise<void> {
  return apiRequest(`/api/categories/${id}`, { method: 'DELETE' });
}

export function useCategories() {
  return useQuery({ queryFn: fetchCategories, queryKey: categoryKeys.all });
}

export function useCreateCategory() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: createCategory,
    onSuccess: async () => client.invalidateQueries({ queryKey: categoryKeys.all }),
  });
}

export function useDeleteCategory() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: deleteCategory,
    onSuccess: async () => client.invalidateQueries({ queryKey: categoryKeys.all }),
  });
}
